/* eslint-disable unicorn/prefer-structured-clone */
import { z } from 'zod';
import { en } from 'zod/v4/locales';
import { getValidationPrettyError } from "../instruments.js";
import { fillForm } from "./fillForm.js";
import { getForm } from "./getForm.js";
import { getInstruments } from "./getInstruments.js";
import { DEFAULT_SOLVENT, updateIconNMR } from "./updateIconNMR.js";
z.config(en());
export class ExperimentForm {
    document;
    id;
    html;
    instrument = null;
    experiments = [];
    iconNMR;
    iconNMROptions;
    solventMapping = {};
    onFormChange;
    constructor(document, options = {}) {
        this.document = document;
        const form = getForm(options);
        this.id = options.id ?? form.id;
        this.html = form.html;
        this.iconNMR = '';
        this.iconNMROptions = {
            user: 'defaultUser',
            name: 'defaultName',
            title: 'defaultTitle',
            holder: 0,
            solvent: DEFAULT_SOLVENT,
            deleteExistingHolder: false,
            autoSubmit: false,
            defaultParameters: {},
        };
        updateIconNMR(this);
        this.onFormChange = (formData) => {
            this.instrument = formData.instrument;
            this.experiments = JSON.parse(JSON.stringify(formData.experiments)).filter((experiment) => experiment.enabled);
            updateIconNMR(this);
            options.onFormChange?.(formData);
        };
    }
    updateIconNMROptions(options) {
        this.iconNMROptions = options;
        updateIconNMR(this);
    }
    fillForm(request, instruments) {
        // The request solvent is a solventMapping key (the user-facing name); store
        // it directly as the selected solvent. It is mapped to the IconNMR name only
        // when generating the file.
        const requestSolvent = request?.analysis?.data?.solvent;
        if (requestSolvent) {
            this.iconNMROptions.solvent = requestSolvent;
        }
        fillForm(this, getInstruments(request, instruments));
    }
    getInstrumentsConfigError(instruments) {
        return getValidationPrettyError(instruments);
    }
}
//# sourceMappingURL=ExperimentForm.js.map